/**
   * Converts a data URL to a blob
   * inspired by http://stackoverflow.com/a/5100158
   */
export function convertDataUrlToBlob(dataUrl) {
  if (!isDataUrl(dataUrl)) {
    throw new Error('dataUrl is not a data URL.');
  }

  // convert base64/URLEncoded data component to raw binary data held in a string
  const [headerPart, encodedData] = dataUrl.split(',');
  const decode = (headerPart.indexOf('base64') >= 0) ? atob : unescape;
  const dataAsByteString = decode(encodedData);

  // separate out the mime component
  const mimeString = headerPart.split(':')[1].split(';')[0];

  // write the bytes of the string to a typed array
  const dataAsByteArray = new Uint8Array(dataAsByteString.length);
  Object.keys(dataAsByteString).forEach((index) => {
    dataAsByteArray[index] = dataAsByteString.charCodeAt(index);
  });

  return new Blob([dataAsByteArray], { type: mimeString });
}

/**
   * Tests whether the specified url is a data url.
   * This is a really simple implementation, just looking at the start of the URL. Feel free to expand it if needed.
  */
export function isDataUrl(url) {
  return typeof url === 'string' && url.trim().toLowerCase().startsWith('data');
}
